import apiClient from '../clients/apiClient.js';
export const fetchOrganizationData = async () => {
  try {
    const response = await apiClient.get('/manage-account'); // Base URL and credentials handled by apiClient
    return response.data; // Access the parsed data directly
  } catch (error) {
    console.error('Error fetching organization data', error);
    return { error: error.message };
  }
};
